/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskProfileResidualRiskUpdate
 */
export interface RiskProfileResidualRiskUpdate {
  /**
   *
   * @type {number}
   * @memberof RiskProfileResidualRiskUpdate
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof RiskProfileResidualRiskUpdate
   */
  overrideJustification?: number | null;
  /**
   *
   * @type {string}
   * @memberof RiskProfileResidualRiskUpdate
   */
  mitigation?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RiskProfileResidualRiskUpdate
   */
  isApplicable?: boolean;
}

/**
 * Check if a given object implements the RiskProfileResidualRiskUpdate interface.
 */
export function instanceOfRiskProfileResidualRiskUpdate(value: object): value is RiskProfileResidualRiskUpdate {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function RiskProfileResidualRiskUpdateFromJSON(json: any): RiskProfileResidualRiskUpdate {
  return RiskProfileResidualRiskUpdateFromJSONTyped(json, false);
}

export function RiskProfileResidualRiskUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskProfileResidualRiskUpdate {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    overrideJustification: json['override_justification'] == null ? undefined : json['override_justification'],
    mitigation: json['mitigation'] == null ? undefined : json['mitigation'],
    isApplicable: json['is_applicable'] == null ? undefined : json['is_applicable'],
  };
}

export function RiskProfileResidualRiskUpdateToJSON(value?: Omit<RiskProfileResidualRiskUpdate, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    override_justification: value['overrideJustification'],
    mitigation: value['mitigation'],
    is_applicable: value['isApplicable'],
  };
}
